module.exports = __webpack_public_path__ + "img/pexels-mikotoraw-3737392.4eed1632.jpg";